var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00914 24.0244C3.97904 24.0244 0 28.0034 0 33.0335C0 38.0636 3.97904 42.0427 9.00914 42.0427C14.0392 42.0427 18.0183 38.0636 18.0183 33.0335C18.0183 28.0034 14.0392 24.0244 9.00914 24.0244ZM9.00914 38.0636C6.23132 38.0636 3.97904 35.8864 3.97904 33.0335C3.97904 30.1806 6.15625 28.0034 9.00914 28.0034C11.862 28.0034 14.0392 30.1806 14.0392 33.0335C14.0392 35.8864 11.787 38.0636 9.00914 38.0636Z",
    fill: "url(#paint0_linear_7730_11315)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00914 24.0244C3.97904 24.0244 0 28.0034 0 33.0335C0 38.0636 3.97904 42.0427 9.00914 42.0427C14.0392 42.0427 18.0183 38.0636 18.0183 33.0335C18.0183 28.0034 14.0392 24.0244 9.00914 24.0244ZM9.00914 38.0636C6.23132 38.0636 3.97904 35.8864 3.97904 33.0335C3.97904 30.1806 6.15625 28.0034 9.00914 28.0034C11.862 28.0034 14.0392 30.1806 14.0392 33.0335C14.0392 35.8864 11.787 38.0636 9.00914 38.0636Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0401 24.0244C34.01 24.0244 30.031 28.0034 30.031 33.0335C30.031 38.0636 34.01 42.0427 39.0401 42.0427C44.0702 42.0427 48.0493 38.0636 48.0493 33.0335C48.0493 28.0034 43.845 24.0244 39.0401 24.0244ZM39.0401 38.0636C36.2623 38.0636 34.01 35.8864 34.01 33.0335C34.01 30.1806 36.1872 28.0034 39.0401 28.0034C41.893 28.0034 44.0702 30.1806 44.0702 33.0335C44.0702 35.8864 41.6678 38.0636 39.0401 38.0636Z",
    fill: "url(#paint1_linear_7730_11315)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0401 24.0244C34.01 24.0244 30.031 28.0034 30.031 33.0335C30.031 38.0636 34.01 42.0427 39.0401 42.0427C44.0702 42.0427 48.0493 38.0636 48.0493 33.0335C48.0493 28.0034 43.845 24.0244 39.0401 24.0244ZM39.0401 38.0636C36.2623 38.0636 34.01 35.8864 34.01 33.0335C34.01 30.1806 36.1872 28.0034 39.0401 28.0034C41.893 28.0034 44.0702 30.1806 44.0702 33.0335C44.0702 35.8864 41.6678 38.0636 39.0401 38.0636Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0604 20.0454C35.661 20.8713 37.0875 21.0214 37.8382 20.4208C38.6641 19.8202 38.8142 18.3937 38.2136 17.643L31.6069 9.23444L31.4567 9.00922C30.6309 8.18338 29.4297 8.03323 28.2285 8.63384L19.2193 13.8141C18.3935 14.1895 18.0181 15.0153 18.0181 15.8411C18.0181 16.667 18.2433 17.4177 18.6187 17.8682L21.6218 21.2466C21.9971 21.622 22.2224 22.2226 22.2224 22.8232V28.0035C22.2224 29.2047 23.0482 30.0305 24.2494 30.0305C25.4507 30.0305 26.2765 29.2047 26.2765 28.0035V22.8232C26.2765 21.2466 25.6759 19.8202 24.6999 18.619L22.6728 16.4418L29.2795 12.6129L35.0604 20.0454Z",
    fill: "url(#paint2_linear_7730_11315)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0604 20.0454C35.661 20.8713 37.0875 21.0214 37.8382 20.4208C38.6641 19.8202 38.8142 18.3937 38.2136 17.643L31.6069 9.23444L31.4567 9.00922C30.6309 8.18338 29.4297 8.03323 28.2285 8.63384L19.2193 13.8141C18.3935 14.1895 18.0181 15.0153 18.0181 15.8411C18.0181 16.667 18.2433 17.4177 18.6187 17.8682L21.6218 21.2466C21.9971 21.622 22.2224 22.2226 22.2224 22.8232V28.0035C22.2224 29.2047 23.0482 30.0305 24.2494 30.0305C25.4507 30.0305 26.2765 29.2047 26.2765 28.0035V22.8232C26.2765 21.2466 25.6759 19.8202 24.6999 18.619L22.6728 16.4418L29.2795 12.6129L35.0604 20.0454Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0125 9.98513C39.7903 9.98513 42.0426 7.80792 42.0426 4.95503C42.0426 2.10213 39.8654 0 37.0125 0C34.2347 0 31.9824 2.17721 31.9824 5.0301C31.9824 7.883 34.2347 9.98513 37.0125 9.98513ZM37.0125 3.97904C37.6131 3.97904 37.9885 4.35442 37.9885 4.95503C37.9885 5.55564 37.6131 5.93102 37.0125 5.93102C36.4119 5.93102 36.0365 5.55564 36.0365 4.95503C36.0365 4.42949 36.4119 3.97904 37.0125 3.97904Z",
    fill: "url(#paint3_linear_7730_11315)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0125 9.98513C39.7903 9.98513 42.0426 7.80792 42.0426 4.95503C42.0426 2.10213 39.8654 0 37.0125 0C34.2347 0 31.9824 2.17721 31.9824 5.0301C31.9824 7.883 34.2347 9.98513 37.0125 9.98513ZM37.0125 3.97904C37.6131 3.97904 37.9885 4.35442 37.9885 4.95503C37.9885 5.55564 37.6131 5.93102 37.0125 5.93102C36.4119 5.93102 36.0365 5.55564 36.0365 4.95503C36.0365 4.42949 36.4119 3.97904 37.0125 3.97904Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7730_11315",
    x1: 9.36554,
    y1: 6.057,
    x2: 35.6264,
    y2: 38.0705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7730_11315",
    x1: 9.36554,
    y1: 6.057,
    x2: 35.6264,
    y2: 38.0705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7730_11315",
    x1: 9.36554,
    y1: 6.057,
    x2: 35.6264,
    y2: 38.0705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7730_11315",
    x1: 9.36554,
    y1: 6.057,
    x2: 35.6264,
    y2: 38.0705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98D1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.1941d56df6724ae8b528aa10113e6736.svg";
export { ForwardRef as ReactComponent };